import axios from "axios";

const RECIBOS_PENDENTES_KEY = "recibosPendentesPagamento";

function gerarIdLocal(recibo) {
  return (
    recibo.referenciaPagamento ||
    `${recibo.idUsuario}-${recibo.dataTransacao}-${recibo.valor}-${recibo.plano}`
  );
}

function lerPendentes() {
  try {
    const pendentes = JSON.parse(localStorage.getItem(RECIBOS_PENDENTES_KEY));
    return Array.isArray(pendentes) ? pendentes : [];
  } catch (erro) {
    return [];
  }
}

function guardarPendentes(pendentes) {
  localStorage.setItem(RECIBOS_PENDENTES_KEY, JSON.stringify(pendentes));
}

function guardarPendente(recibo) {
  const idLocal = gerarIdLocal(recibo);
  const pendentes = lerPendentes().filter((item) => gerarIdLocal(item) !== idLocal);
  guardarPendentes([...pendentes, { ...recibo, idLocal }]);
}

function removerPendente(recibo) {
  const idLocal = gerarIdLocal(recibo);
  guardarPendentes(lerPendentes().filter((item) => gerarIdLocal(item) !== idLocal));
}

function esperar(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function montarReciboPagamento({
  idUsuario,
  userName,
  numeroTelefone,
  valor,
  plano,
  descricao,
  dataTransacao,
  referenciaPagamento,
}) {
  return {
    idUsuario,
    userName: userName || "Cliente",
    meioPagamento: "Mpesa",
    numeroTelefone: String(numeroTelefone || "").replace(/^258/, "") || "Mpesa",
    valor: Number(valor) || 0,
    plano: plano || "Plano",
    descricao: descricao || plano || "Pagamento",
    dataTransacao,
    referenciaPagamento,
  };
}

export async function criarReciboPagamento({ apiUrl, token, recibo, tentativas = 3 }) {
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  let ultimoErro = null;

  for (let tentativa = 1; tentativa <= tentativas; tentativa += 1) {
    try {
      const resposta = await axios.post(`${apiUrl}/recibo`, recibo, { headers });
      removerPendente(recibo);
      return resposta;
    } catch (erro) {
      ultimoErro = erro;
      if (tentativa < tentativas) {
        await esperar(700 * tentativa);
      }
    }
  }

  guardarPendente(recibo);
  throw ultimoErro;
}

export async function sincronizarRecibosPendentes({ apiUrl, token }) {
  const pendentes = lerPendentes();
  if (!pendentes.length || !token) return;

  for (const recibo of pendentes) {
    try {
      await criarReciboPagamento({ apiUrl, token, recibo, tentativas: 1 });
    } catch (erro) {
      return;
    }
  }
}
